export const book = Object.freeze({
  notifications: 'notifications',
  nineSquare: 'nineSquare',
  qr: 'qr',
});
